// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  --eventColor: var(--loginButtonBgColor, #3A67FA);
  --eventTextColor: var(--loginButtonTextColor, #FFF);
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
*::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
*::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
*::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

ion-content {
  --background: transparent;
  position: relative;
}

.backgroundImg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.background-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  mix-blend-mode: normal;
}

img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.hotsite-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 30px;
  max-width: 100%;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  padding: 0px 32px;
}

.fivents-logo img {
  width: 100%;
  height: 100%;
  max-width: 150px;
  max-height: 50px;
}

.signIn-signUp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.signIn-signUp button {
  font-size: 1.125rem;
  font-weight: 400;
  border-radius: 8px;
  padding: 8px 18px;
  border: 2px solid var(--eventColor);
  transition: all 0.1s ease-in-out;
}

.sign-in {
  background: transparent;
  color: var(--eventColor);
  opacity: 0.802;
}
.sign-in:hover {
  background: var(--eventColor);
  color: var(--eventTextColor);
  opacity: 1;
}

.sign-up {
  background: var(--eventColor);
  color: var(--eventTextColor);
  opacity: 0.802;
}
.sign-up:hover {
  opacity: 1;
}

#counterDateEvent {
  display: flex;
  margin: 2rem 0;
}
#counterDateEvent .timer {
  display: flex;
  gap: clamp(10px, 2vw, 20px);
  flex-wrap: wrap;
}
#counterDateEvent .box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 70px;
  padding: clamp(8px, 1.8vw, 18px) clamp(10px, 2vw, 20px);
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
  text-align: center;
  overflow: hidden;
  isolation: isolate;
}
#counterDateEvent .box .value {
  font-size: clamp(1rem, 2.5vw, 1.8rem);
  font-weight: 700;
  color: #ffffff; /* Forçando branco */
  line-height: 1.1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
#counterDateEvent .box .label {
  font-size: clamp(0.6rem, 1.2vw, 0.9rem);
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #ffffff;
  opacity: 0.9;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 100%;
  width: 100%;
}

#home {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1rem;
  text-align: start;
  padding: 1.5rem;
  width: 100%;
  height: 100%;
  min-height: 300px;
  border-radius: 6px;
}

#home .title-descri {
  z-index: 1;
  color: #FFF;
  width: 100%;
  max-width: 770px;
  margin-bottom: 1rem;
}
#home .title-descri h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  margin-bottom: 0.75rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  white-space: pre-wrap;
}
#home .title-descri div {
  line-height: 130%;
  font-size: 1rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  white-space: pre-wrap;
  margin-bottom: 2rem;
}
#home .title-descri p {
  line-height: 130%;
  font-size: 1rem;
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  white-space: pre-wrap;
  margin-bottom: 2rem;
}
#home .title-descri .buy-now-btn {
  display: inline-block;
  padding: 12px 24px;
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 0.5rem;
  z-index: 2;
  position: relative;
}
#home .title-descri .buy-now-btn:hover {
  background: #ffffff;
  color: #000000;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}
#home .title-descri .buy-now-btn:active {
  transform: translateY(0);
}

.session-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.session-title img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 4px;
}
.session-title h2 {
  font-size: 1.25rem;
  font-weight: bold;
}

#schedule {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #C6C6C6;
}

.schedule-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.schedule-header > p {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 130%;
}

.sessions-info {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template: "session-content sessions";
  gap: 15px;
  justify-content: space-between;
}

.sessions {
  grid-area: sessions;
  padding: 5px;
  max-width: 350px;
  border-bottom: 1px solid #C6C6C6;
}

.dates-box {
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: auto;
  max-width: calc(100vw - 40px);
  padding-bottom: 10px;
  border-bottom: 1px solid #C6C6C6;
}

.date {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 130%;
  background: var(--eventColor);
  opacity: 0.502;
  color: var(--eventTextColor);
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.date.active {
  background: var(--eventColor);
  opacity: 1;
}

.sessions-box {
  max-height: 400px;
  overflow-y: auto;
}
.sessions-box ion-item {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.sessions-box ion-item:hover {
  --border-color: var(--eventColor);
}
.sessions-box ion-label {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sessions-box ion-label h4 {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 130%;
  max-width: 350px;
}

.session-date {
  display: flex;
  align-items: center;
  gap: 30px;
}
.session-date div {
  display: flex;
  align-items: center;
  gap: 5px;
}

.session-content {
  grid-area: session-content;
  padding: 5px;
  max-width: 600px;
  padding: 0 20px;
}
.session-content > h5 {
  margin-top: 30px;
  font-size: 1.125rem;
  font-weight: bold;
  line-height: 130%;
}

.session-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.session-description {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 130%;
}

.session-speakers {
  display: flex;
  align-items: center;
  gap: 20px;
  overflow: auto;
  max-width: calc(100vw - 40px);
}

.session-speaker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 100px;
  max-width: 100px;
  text-align: center;
}
.session-speaker img {
  width: 50px;
  height: 50px;
  border-radius: 100%;
}
.session-speaker span {
  font-size: 1rem;
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  white-space: pre-wrap;
}

#speakers, #infobooth, #sponsors, .infobooth-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 15px;
  width: 100%;
  border-bottom: 1px solid #C6C6C6;
  padding-bottom: 10px;
}

.infobooth-container {
  border-bottom: none;
}

.speakers-box, .sponsors-box {
  width: 100%;
}
.speakers-box ion-list, .sponsors-box ion-list {
  display: flex;
  align-items: center;
  gap: 15px;
  overflow: auto;
}
.speakers-box ion-item, .sponsors-box ion-item {
  min-width: 190px;
  max-width: 190px;
  cursor: pointer;
}
.speakers-box ion-item ion-label, .sponsors-box ion-item ion-label {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  min-width: 150px;
  max-width: 150px;
}
.speakers-box ion-item ion-label img, .sponsors-box ion-item ion-label img {
  width: 100%;
  max-width: 150px;
  border-radius: 6px 6px 0 0;
}
.speakers-box ion-item ion-label h4, .sponsors-box ion-item ion-label h4 {
  font-size: 1.125rem;
}
.speakers-box ion-item ion-label p, .sponsors-box ion-item ion-label p {
  font-size: 1rem;
}
.speakers-box ion-item ion-label p, .speakers-box ion-item ion-label h4, .sponsors-box ion-item ion-label p, .sponsors-box ion-item ion-label h4 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  white-space: pre-wrap;
  font-weight: 400;
  line-height: 130%;
}

.infobooth-box {
  width: 100%;
  min-height: 600px;
  overflow-y: auto;
}
.infobooth-box iframe {
  min-width: 100%;
  min-height: 100%;
  border: none;
}

@media (max-width: 950px) {
  #schedule {
    grid-template-columns: 1fr;
  }
  .sessions-info {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr;
    grid-template: "sessions" "session-content";
  }
  .sessions {
    max-width: 100%;
  }
  .sessions-box ion-label h4 {
    max-width: calc(100vw - 60px);
  }
  .session-content {
    max-width: calc(100vw - 30px);
  }
}
.event-status-box {
  min-width: 120px;
}
.event-status-box .value {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
}
.event-status-box .label {
  font-size: clamp(0.7rem, 1.5vw, 0.9rem);
  text-align: center;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  opacity: 0.7;
}
.empty-state p {
  font-size: 1rem;
  font-style: italic;
  margin: 0;
}

.hotsite-sections {
  z-index: 1;
  width: 100%;
}
.hotsite-sections .section-container {
  width: 100%;
  margin-bottom: 30px;
}
.hotsite-sections .content-section {
  background: rgba(255, 255, 255, 0.35);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}
.hotsite-sections .content-section .section-header {
  text-align: center;
  margin-bottom: 30px;
}
.hotsite-sections .content-section .section-header .section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
}
.hotsite-sections .content-section .section-header .section-title .section-logo {
  height: 40px;
  width: auto;
}
.hotsite-sections .content-section .section-header .section-title h2 {
  font-size: clamp(1.5rem, 3vw, 2.5rem);
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
}
.hotsite-sections .content-section .section-header .section-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #7f8c8d;
  margin: 0 auto;
}
.hotsite-sections .speakers-section .speakers-carousel {
  align-self: center;
  position: relative;
  padding: 0 50px;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 10;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn:hover:not(:disabled) {
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%) scale(1.1);
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn.prev {
  left: 0;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn.next {
  right: 0;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-btn ion-icon {
  font-size: 24px;
  color: #2c3e50;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px 0;
  justify-content: center;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large {
  flex: 0 0 180px;
  width: 180px;
  height: 240px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large .speaker-photo {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large .speaker-photo img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large .speaker-info .speaker-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50 !important;
  margin-bottom: 5px;
}
.hotsite-sections .speakers-section .speakers-carousel .speakers-grid .speaker-card-large .speaker-info .speaker-title {
  font-size: 0.9rem;
  color: #7f8c8d !important;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-pagination .pagination-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  padding: 0;
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-pagination .pagination-dot:hover {
  background: rgba(0, 0, 0, 0.4);
  transform: scale(1.2);
}
.hotsite-sections .speakers-section .speakers-carousel .carousel-pagination .pagination-dot.active {
  background: var(--titleColor, #2c3e50);
  width: 24px;
  border-radius: 5px;
}
.hotsite-sections .sponsors-section .sponsors-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px 0;
  justify-content: center;
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card {
  flex: 0 0 calc(12.5% - 15px);
  min-width: 160px;
  max-width: 220px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card .sponsor-logo {
  margin-bottom: 15px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card .sponsor-logo img {
  max-width: 120px;
  max-height: 80px;
  object-fit: contain;
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card .sponsor-info .sponsor-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50 !important;
  margin-bottom: 5px;
}
.hotsite-sections .sponsors-section .sponsors-grid .sponsor-card .sponsor-info .sponsor-category {
  font-size: 0.9rem;
  color: #7f8c8d !important;
}
.hotsite-sections .schedule-section .schedule-content .schedule-navigation {
  margin-bottom: 25px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-navigation .dates-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.hotsite-sections .schedule-section .schedule-content .schedule-navigation .dates-selector .date-tab {
  padding: 10px 20px;
  border-radius: 25px;
  background: white;
  border: 2px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #2c3e50;
}
.hotsite-sections .schedule-section .schedule-content .schedule-navigation .dates-selector .date-tab.active, .hotsite-sections .schedule-section .schedule-content .schedule-navigation .dates-selector .date-tab:hover {
  background: var(--loginButtonBgColor, #3498db);
  color: white;
  border-color: var(--loginButtonBgColor, #3498db);
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 20px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list {
  background: white;
  border-radius: 12px;
  padding: 15px;
  max-height: 600px;
  overflow-y: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item:hover {
  background: #e9ecef;
  border-left-color: var(--loginButtonBgColor, #3498db);
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item.selected {
  background: #e3f2fd;
  border-left-color: var(--loginButtonBgColor, #3498db);
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item .session-name {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50 !important;
  margin-bottom: 8px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item .session-meta {
  display: flex;
  gap: 15px;
  font-size: 0.85rem;
  color: #7f8c8d !important;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item .session-meta .session-date, .hotsite-sections .schedule-section .schedule-content .schedule-layout .sessions-list .session-item .session-meta .session-time {
  display: flex;
  align-items: center;
  gap: 5px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-detail-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2c3e50 !important;
  margin-bottom: 15px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-description {
  color: #34495e !important;
  line-height: 1.6;
  margin-bottom: 20px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section {
  margin-top: 20px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section .speakers-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50 !important;
  margin-bottom: 15px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section .speakers-grid {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section .speakers-grid .speaker-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
  padding: 10px 15px;
  border-radius: 8px;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section .speakers-grid .speaker-card .speaker-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.hotsite-sections .schedule-section .schedule-content .schedule-layout .session-details .session-speakers-section .speakers-grid .speaker-card .speaker-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c3e50 !important;
}
.hotsite-sections .infobooth-section .infobooth-content {
  width: 100%;
  height: 600px;
  background: white;
  border-radius: 12px;
  padding: 30px;
  color: #34495e !important;
  line-height: 1.8;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

@media (max-width: 950px) {
  .hotsite-container {
    padding: 15px;
    gap: 20px;
  }
  .content-section {
    padding: 20px !important;
  }
  .schedule-section .schedule-content .schedule-layout {
    grid-template-columns: 1fr !important;
  }
  .speakers-section .speakers-carousel {
    padding: 0 40px;
  }
  .speakers-section .speakers-carousel .carousel-btn {
    width: 35px;
    height: 35px;
  }
  .speakers-section .speakers-carousel .carousel-btn ion-icon {
    font-size: 20px;
  }
  .speakers-section .speakers-carousel .speakers-grid .speaker-card-large {
    flex: 0 0 160px;
    width: 160px;
    height: 220px;
  }
  .sponsors-section .sponsors-carousel {
    padding: 0 40px;
  }
  .sponsors-section .sponsors-carousel .carousel-btn {
    width: 35px;
    height: 35px;
  }
  .sponsors-section .sponsors-carousel .carousel-btn ion-icon {
    font-size: 20px;
  }
  .sponsors-section .sponsors-carousel .sponsors-grid-carousel .sponsor-card {
    flex: 0 0 calc(25% - 15px);
    min-width: 120px;
  }
  .sponsors-section .sponsors-grid .sponsor-card {
    flex: 0 0 calc(25% - 15px);
    min-width: 120px;
  }
  .sponsors-section .sponsors-grid .sponsor-card {
    flex: 0 0 160px;
  }
  #schedule {
    grid-template-columns: 1fr;
  }
  .sessions-info {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr;
    grid-template: "sessions" "session-content";
  }
  .sessions {
    max-width: 100%;
  }
  .sessions-box ion-label h4 {
    max-width: calc(100vw - 60px);
  }
  .session-content {
    max-width: calc(100vw - 30px);
  }
}
@media (max-width: 600px) {
  .speakers-section .speakers-carousel {
    padding: 0 30px;
  }
  .speakers-section .speakers-carousel .carousel-btn {
    width: 30px;
    height: 30px;
  }
  .speakers-section .speakers-carousel .carousel-btn ion-icon {
    font-size: 18px;
  }
  .speakers-section .speakers-carousel .speakers-grid .speaker-card-large {
    flex: 0 0 150px;
    width: 150px;
    height: 210px;
  }
  .sponsors-section .sponsors-carousel {
    padding: 0 30px;
  }
  .sponsors-section .sponsors-carousel .carousel-btn {
    width: 30px;
    height: 30px;
  }
  .sponsors-section .sponsors-carousel .carousel-btn ion-icon {
    font-size: 18px;
  }
  .sponsors-section .sponsors-carousel .sponsors-grid-carousel .sponsor-card {
    flex: 0 0 calc(50% - 10px);
    min-width: 130px;
  }
  .sponsors-section .sponsors-grid .sponsor-card {
    flex: 0 0 calc(50% - 10px);
    min-width: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/hotsite/hotsite.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,gDAAA;EACA,mDAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAEF;AACE;EACE,UAAA;EACA,WAAA;AACJ;AAEE;EACE,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AAFJ;;AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAFF;AAIE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,uBAAA;EACA,wBAAA;EACA,cAAA;AAHF;AAKE;EACE,6BAAA;EACA,4BAAA;EACA,UAAA;AAHJ;;AAOA;EACE,6BAAA;EACA,4BAAA;EACA,cAAA;AAJF;AAME;EACE,UAAA;AAJJ;;AAQA;EACE,aAAA;EACA,cAAA;AALF;AAOE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;AALJ;AAQE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,uDAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAQI;EACE,qCAAA;EACA,gBAAA;EACA,cAAA,EAAA,oBAAA;EACA,gBAAA;EACA,2CAAA;AANN;AASI;EACE,uCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AAPN;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AATF;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EAEA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAVF;AAYE;EACE,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AAVJ;AAaE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAZJ;AAeE;EACE,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAbJ;AAeI;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,+CAAA;AAbN;AAgBI;EACE,wBAAA;AAdN;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,gCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAlBF;AAoBE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,8BAAA;EACA,yCAAA;EACA,SAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;EACA,gCAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAnBF;AAqBE;EACE,6BAAA;EACA,UAAA;AAnBJ;;AAuBA;EACE,iBAAA;EACA,gBAAA;AApBF;AAsBE;EACE,eAAA;EACA,gCAAA;AApBJ;AAsBI;EACE,iCAAA;AApBN;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAtBN;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAxBJ;;AA4BA;EACE,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAzBJ;;AA6BA;EACE,iBAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA1BF;AA4BE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AA5BF;;AA+BA;EACE,mBAAA;AA5BF;;AA+BA;EACE,WAAA;AA5BF;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA9BJ;AAgCI;EACE,WAAA;EACA,gBAAA;EACA,0BAAA;AA9BN;AAiCI;EACE,mBAAA;AA/BN;AAkCI;EACE,eAAA;AAhCN;AAmCI;EACE,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AAjCN;;AAsCA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;AAnCF;AAqCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AAnCJ;;AAyCA;EACE;IACE,0BAAA;EAtCF;EAyCA;IACE,0BAAA;IACA,2BAAA;IACA,2CAAA;EAvCF;EA0CA;IACE,eAAA;EAxCF;EA2CA;IACE,6BAAA;EAzCF;EA4CA;IACE,6BAAA;EA1CF;AACF;AA+CA;EACE,gBAAA;AA7CF;AA+CE;EAEE,qCAAA;AA9CJ;AAiDE;EAEE,uCAAA;EACA,kBAAA;AAhDJ;;AAoDA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAjDF;AAmDE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAjDJ;;AAqDA;EACE,UAAA;EACA,WAAA;AAlDF;AAoDE;EACE,WAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AAnDJ;AAqDI;EACE,kBAAA;EACA,mBAAA;AAnDN;AAqDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAnDR;AAqDQ;EACE,YAAA;EACA,WAAA;AAnDV;AAsDQ;EACE,qCAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AApDV;AAwDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAtDR;AA4DI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AA1DN;AA4DM;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,yBAAA;EACA,WAAA;AA1DR;AA4DQ;EACE,iBAAA;EACA,0CAAA;EACA,sCAAA;AA1DV;AA6DQ;EACE,YAAA;EACA,mBAAA;AA3DV;AA8DQ;EACE,OAAA;AA5DV;AA+DQ;EACE,QAAA;AA7DV;AAgEQ;EACE,eAAA;EACA,cAAA;AA9DV;AAkEM;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AAhER;AAkEQ;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhEV;AAkEU;EACE,2BAAA;EACA,0CAAA;AAhEZ;AAmEU;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAjEZ;AAmEY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAjEd;AAsEY;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AApEd;AAuEY;EACE,iBAAA;EACA,yBAAA;AArEd;AA2EM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAzER;AA2EQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;AAzEV;AA2EU;EACE,8BAAA;EACA,qBAAA;AAzEZ;AA4EU;EACE,sCAAA;EACA,WAAA;EACA,kBAAA;AA1EZ;AAkFI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AAhFN;AAkFM;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,+BAAA;AAhFR;AAkFQ;EACE,2BAAA;EACA,0CAAA;AAhFV;AAmFQ;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjFV;AAmFU;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjFZ;AAsFU;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AApFZ;AAuFU;EACE,iBAAA;EACA,yBAAA;AArFZ;AA8FM;EACE,mBAAA;AA5FR;AA8FQ;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AA5FV;AA8FU;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AA5FZ;AA8FY;EACE,8CAAA;EACA,YAAA;EACA,gDAAA;AA5Fd;AAkGM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAhGR;AAkGQ;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;AAhGV;AAkGU;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;AAhGZ;AAkGY;EACE,mBAAA;EACA,qDAAA;AAhGd;AAmGY;EACE,mBAAA;EACA,qDAAA;EACA,6CAAA;AAjGd;AAoGY;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAlGd;AAqGY;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AAnGd;AAqGc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnGhB;AAyGQ;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AAvGV;AAyGU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAvGZ;AA0GU;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AAxGZ;AA2GU;EACE,gBAAA;AAzGZ;AA2GY;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAzGd;AA4GY;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA1Gd;AA4Gc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA1GhB;AA6GkB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA3GpB;AA+GgB;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AA7GlB;AAyHI;EACE,WAAA;EACA,aAAA;EAEA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,0CAAA;AAxHN;;AA6HA;EACE;IACE,aAAA;IACA,SAAA;EA1HF;EA6HA;IACE,wBAAA;EA3HF;EA8HA;IACE,qCAAA;EA5HF;EA+HA;IACE,eAAA;EA7HF;EA+HE;IACE,WAAA;IACA,YAAA;EA7HJ;EA+HI;IACE,eAAA;EA7HN;EAkII;IACE,eAAA;IACA,YAAA;IACA,aAAA;EAhIN;EAqIA;IACE,eAAA;EAnIF;EAqIE;IACE,WAAA;IACA,YAAA;EAnIJ;EAqII;IACE,eAAA;EAnIN;EAwII;IACE,0BAAA;IACA,gBAAA;EAtIN;EA4IE;IACE,0BAAA;IACA,gBAAA;EA1IJ;EA8IA;IACE,eAAA;EA5IF;EA+IA;IACE,0BAAA;EA7IF;EAgJA;IACE,0BAAA;IACA,2BAAA;IACA,2CAAA;EA9IF;EAiJA;IACE,eAAA;EA/IF;EAkJA;IACE,6BAAA;EAhJF;EAmJA;IACE,6BAAA;EAjJF;AACF;AAoJA;EACE;IACE,eAAA;EAlJF;EAoJE;IACE,WAAA;IACA,YAAA;EAlJJ;EAoJI;IACE,eAAA;EAlJN;EAuJI;IACE,eAAA;IACA,YAAA;IACA,aAAA;EArJN;EA0JA;IACE,eAAA;EAxJF;EA0JE;IACE,WAAA;IACA,YAAA;EAxJJ;EA0JI;IACE,eAAA;EAxJN;EA6JI;IACE,0BAAA;IACA,gBAAA;EA3JN;EAiKE;IACE,0BAAA;IACA,gBAAA;EA/JJ;AACF","sourcesContent":["* { \n  --eventColor: var(--loginButtonBgColor, #3A67FA);\n  --eventTextColor: var(--loginButtonTextColor, #FFF);\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n\n  // scrollbars customization\n  &::-webkit-scrollbar {\n    width: 5px; \n    height: 5px; \n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; \n    border-radius: 10px; \n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: #f1f1f1; \n  }\n}\n\nion-content {\n  --background: transparent;\n  position: relative;\n}\n\n.backgroundImg{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: -1;\n}\n\n.background-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  pointer-events: none;\n  mix-blend-mode: normal;\n}\n\nimg { // avoiding imgs to be dragged\n  -webkit-user-drag: none;\n  -khtml-user-drag: none;\n  -moz-user-drag: none;\n  -o-user-drag: none;\n}\n\n.hotsite-container {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding: 30px;\n  max-width: 100%;\n}\n\nheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 1;\n  padding: 0px 32px;\n}\n\n.fivents-logo img {\n  width: 100%;\n  height: 100%;\n  max-width: 150px;\n  max-height: 50px;\n}\n\n.signIn-signUp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  \n  & button {\n    font-size: 1.125rem;\n    font-weight: 400;\n    border-radius: 8px;\n    padding: 8px 18px;\n    border: 2px solid var(--eventColor);\n    transition: all 0.1s ease-in-out;\n  }\n}\n\n.sign-in {\n  background: transparent;\n  color: var(--eventColor);\n  opacity: 0.802;\n\n  &:hover {\n    background: var(--eventColor);\n    color: var(--eventTextColor);\n    opacity: 1;\n  }\n}\n\n.sign-up {\n  background: var(--eventColor);\n  color: var(--eventTextColor);\n  opacity: 0.802;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n#counterDateEvent {\n  display: flex;\n  margin: 2rem 0;\n\n  .timer {\n    display: flex;\n    gap: clamp(10px, 2vw, 20px);\n    flex-wrap: wrap;\n  }\n\n  .box {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    min-width: 70px;\n    padding: clamp(8px, 1.8vw, 18px) clamp(10px, 2vw, 20px);\n    background: rgba(255,255,255,0.15);\n    border: 2px solid rgba(255,255,255,0.25);\n    border-radius: 12px;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    box-shadow: 0 4px 15px rgba(0,0,0,0.25);\n    text-align: center;\n    overflow: hidden;\n    isolation: isolate;\n\n    .value {\n      font-size: clamp(1rem, 2.5vw, 1.8rem);\n      font-weight: 700;\n      color: #ffffff; /* Forçando branco */\n      line-height: 1.1;\n      text-shadow: 1px 1px 2px rgba(0,0,0,0.5);\n    }\n\n    .label {\n      font-size: clamp(0.6rem, 1.2vw, 0.9rem);\n      font-weight: 500;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n      color: #ffffff; \n      opacity: 0.9;\n    }\n  }\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  max-width: 100%;\n  width: 100%;\n}\n\n#home {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 1rem;\n  text-align: start;\n  padding: 1.5rem;\n\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  border-radius: 6px;\n}\n\n#home .title-descri {\n  z-index: 1;\n  color: #FFF;\n  width: 100%;\n  max-width: 770px;\n  margin-bottom: 1rem;\n\n  & h1 {\n    font-size: clamp(2rem, 4vw, 3rem);\n    font-weight: 700;\n    margin-bottom: 0.75rem;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3; \n    line-clamp: 3;\n    white-space: pre-wrap;\n  }\n\n  & div {\n    line-height: 130%;\n    font-size: 1rem;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 5; \n    line-clamp: 5;\n    white-space: pre-wrap;\n    margin-bottom: 2rem;\n  }\n\n  & p {\n    line-height: 130%;\n    font-size: 1rem;\n    font-weight: 400;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 5; \n    line-clamp: 5;\n    white-space: pre-wrap;\n    margin-bottom: 2rem;\n  }\n\n  .buy-now-btn {\n    display: inline-block;\n    padding: 12px 24px;\n    background: transparent;\n    color: #ffffff;\n    border: 2px solid #ffffff;\n    border-radius: 4px;\n    font-size: 1rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: 0.5rem;\n    z-index: 2;\n    position: relative;\n\n    &:hover {\n      background: #ffffff;\n      color: #000000;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n}\n\n.session-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  & img {\n    width: 30px;\n    height: 30px;\n    object-fit: cover;\n    border-radius: 4px;\n  }\n\n  & h2 {\n    font-size: 1.25rem;\n    font-weight: bold;\n  }\n}\n\n#schedule {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #C6C6C6;\n}\n\n.schedule-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n\n  & > p {\n    font-size: 1.125rem;\n    font-weight: 400;\n    line-height: 130%;\n  }\n}\n\n.sessions-info {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template: \"session-content sessions\";\n  gap: 15px;\n  justify-content: space-between;\n}\n\n.sessions {\n  grid-area: sessions;\n  padding: 5px;\n  max-width: 350px;\n  border-bottom: 1px solid #C6C6C6;\n}\n\n.dates-box {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  overflow: auto;\n  max-width: calc(100vw - 40px);\n  padding-bottom: 10px;\n  border-bottom: 1px solid #C6C6C6;\n}\n\n.date {\n  font-size: 1.125rem;\n  font-weight: 400;\n  line-height: 130%;\n  background: var(--eventColor);\n  opacity: 0.502;\n  color: var(--eventTextColor);\n  padding: 5px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.1s ease-in-out;\n\n  &.active {\n    background: var(--eventColor);\n    opacity: 1;\n  }\n}\n\n.sessions-box {\n  max-height: 400px;\n  overflow-y: auto;\n\n  & ion-item {\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      --border-color: var(--eventColor);\n    }\n  }\n\n  & ion-label {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    & h4 {\n      font-size: 1.125rem;\n      font-weight: 400;\n      line-height: 130%;\n      max-width: 350px;\n    }\n  }\n}\n\n.session-date {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n\n  & div {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.session-content {\n  grid-area: session-content;\n  padding: 5px;\n  max-width: 600px;\n  padding: 0 20px;\n\n  & > h5 {\n    margin-top: 30px;\n    font-size: 1.125rem;\n    font-weight: bold;\n    line-height: 130%;\n  }\n}\n\n.session-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.session-description {\n  font-size: 1.125rem;\n  font-weight: 400;\n  line-height: 130%;\n}\n\n.session-speakers {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  overflow: auto;\n  max-width: calc(100vw - 40px);\n}\n\n.session-speaker {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  min-width: 100px;\n  max-width: 100px;\n  text-align: center;\n\n  & img {\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n  }\n\n  & span {\n    font-size: 1rem;\n    font-weight: 400;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    white-space: pre-wrap;\n  }\n}\n\n#speakers, #infobooth, #sponsors, .infobooth-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 15px;\n  width: 100%;\n  border-bottom: 1px solid #C6C6C6;\n  padding-bottom: 10px;\n}\n\n.infobooth-container {\n  border-bottom: none;\n}\n\n.speakers-box, .sponsors-box {\n  width: 100%;\n\n  & ion-list {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    overflow: auto;\n  }\n\n  & ion-item {\n    min-width: 190px;\n    max-width: 190px;\n    cursor: pointer;\n  }\n\n  & ion-item ion-label {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    text-align: center;\n    min-width: 150px;\n    max-width: 150px;\n\n    & img {\n      width: 100%;\n      max-width: 150px;\n      border-radius: 6px 6px 0 0;\n    }\n\n    & h4 {\n      font-size: 1.125rem;\n    }\n\n    & p {\n      font-size: 1rem;\n    }\n\n    & p, & h4 {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 2;\n      line-clamp: 2;\n      white-space: pre-wrap;\n      font-weight: 400;\n      line-height: 130%;\n    }\n  }\n}\n\n.infobooth-box {\n  width: 100%;\n  min-height: 600px;\n  overflow-y: auto;\n\n  & iframe {\n    min-width: 100%;\n    min-height: 100%; \n    border: none;\n  }\n}\n\n\n\n@media (max-width: 950px) {\n  #schedule {\n    grid-template-columns: 1fr;\n  }\n\n  .sessions-info {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 2fr;\n    grid-template: \"sessions\" \"session-content\";\n  }\n\n  .sessions {\n    max-width: 100%;\n  }\n\n  .sessions-box ion-label h4{\n    max-width: calc(100vw - 60px);\n  }\n\n  .session-content {\n    max-width: calc(100vw - 30px);\n  }\n\n\n}\n\n.event-status-box {\n  min-width: 120px;\n  \n  .value {\n\n    font-size: clamp(1.5rem, 4vw, 2.5rem);\n  }\n  \n  .label {\n\n    font-size: clamp(0.7rem, 1.5vw, 0.9rem);\n    text-align: center;\n  }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  opacity: 0.7;\n  \n  p {\n    font-size: 1rem;\n    font-style: italic;\n    margin: 0;\n  }\n}\n\n.hotsite-sections {\n  z-index: 1;\n  width: 100%;\n  \n  .section-container {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n\n  .content-section {\n    background: rgba(255, 255, 255, 0.35); \n    backdrop-filter: blur(10px);\n    border-radius: 16px;\n    padding: 40px;\n    margin-bottom: 30px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n\n    .section-header {\n      text-align: center;\n      margin-bottom: 30px;\n\n      .section-title {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 15px;\n        margin-bottom: 15px;\n\n        .section-logo {\n          height: 40px;\n          width: auto;\n        }\n\n        h2 {\n          font-size: clamp(1.5rem, 3vw, 2.5rem);\n          font-weight: bold;\n          color: #2c3e50;\n          margin: 0;\n        }\n      }\n\n      .section-description {\n        font-size: 1rem;\n        line-height: 1.6;\n        color: #7f8c8d;\n        margin: 0 auto;\n      }\n    }\n  }\n  \n  .speakers-section {\n    .speakers-carousel {\n      align-self: center;\n      position: relative;\n      padding: 0 50px;\n      \n      .carousel-btn {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        background: rgba(255, 255, 255, 0.9);\n        border: none;\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        transition: all 0.3s ease;\n        z-index: 10;\n        \n        &:hover:not(:disabled) {\n          background: white;\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n          transform: translateY(-50%) scale(1.1);\n        }\n        \n        &:disabled {\n          opacity: 0.4;\n          cursor: not-allowed;\n        }\n        \n        &.prev {\n          left: 0;\n        }\n        \n        &.next {\n          right: 0;\n        }\n        \n        ion-icon {\n          font-size: 24px;\n          color: #2c3e50;\n        }\n      }\n      \n      .speakers-grid {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 15px;\n        padding: 10px 0;\n        justify-content: center;\n        \n        .speaker-card-large {\n          flex: 0 0 180px;\n          width: 180px;\n          height: 240px;\n          background: white;\n          border-radius: 12px;\n          padding: 20px;\n          text-align: center;\n          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n          transition: transform 0.3s ease;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          \n          &:hover {\n            transform: translateY(-3px);\n            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n          }\n          \n          .speaker-photo {\n            margin-bottom: 15px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 90px;\n            \n            img {\n              width: 90px;\n              height: 90px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n          }\n          \n          .speaker-info {\n            .speaker-name {\n              font-size: 1.05rem;\n              font-weight: 600;\n              color: #2c3e50 !important;\n              margin-bottom: 5px;\n            }\n            \n            .speaker-title {\n              font-size: 0.9rem;\n              color: #7f8c8d !important;\n            }\n          }\n        }\n      }\n      \n      .carousel-pagination {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        margin-top: 20px;\n        \n        .pagination-dot {\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n          background: rgba(0, 0, 0, 0.2);\n          cursor: pointer;\n          transition: all 0.3s ease;\n          border: none;\n          padding: 0;\n          \n          &:hover {\n            background: rgba(0, 0, 0, 0.4);\n            transform: scale(1.2);\n          }\n          \n          &.active {\n            background: var(--titleColor, #2c3e50);\n            width: 24px;\n            border-radius: 5px;\n          }\n        }\n      }\n    }\n  }\n  \n  .sponsors-section {\n    .sponsors-grid {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 15px;\n      padding: 10px 0;\n      justify-content: center;\n      \n      .sponsor-card {\n        flex: 0 0 calc(12.5% - 15px);\n        min-width: 160px;\n        max-width: 220px;\n        background: white;\n        border-radius: 12px;\n        padding: 20px;\n        text-align: center;\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n        transition: transform 0.3s ease;\n        \n        &:hover {\n          transform: translateY(-3px);\n          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n        }\n        \n        .sponsor-logo {\n          margin-bottom: 15px;\n          height: 80px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          \n          img {\n            max-width: 120px;\n            max-height: 80px;\n            object-fit: contain;\n          }\n        }\n        \n        .sponsor-info {\n          .sponsor-name {\n            font-size: 1.05rem;\n            font-weight: 600;\n            color: #2c3e50 !important;\n            margin-bottom: 5px;\n          }\n          \n          .sponsor-category {\n            font-size: 0.9rem;\n            color: #7f8c8d !important;\n          }\n        }\n      }\n    }\n  }\n  \n  .schedule-section {\n    .schedule-content {\n      .schedule-navigation {\n        margin-bottom: 25px;\n        \n        .dates-selector {\n          display: flex;\n          gap: 10px;\n          flex-wrap: wrap;\n          justify-content: center;\n          \n          .date-tab {\n            padding: 10px 20px;\n            border-radius: 25px;\n            background: white;\n            border: 2px solid #e0e0e0;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            font-weight: 500;\n            color: #2c3e50;\n            \n            &.active, &:hover {\n              background: var(--loginButtonBgColor, #3498db);\n              color: white;\n              border-color: var(--loginButtonBgColor, #3498db);\n            }\n          }\n        }\n      }\n      \n      .schedule-layout {\n        display: grid;\n        grid-template-columns: 1fr 2fr;\n        gap: 20px;\n        \n        .sessions-list {\n          background: white;\n          border-radius: 12px;\n          padding: 15px;\n          max-height: 600px;\n          overflow-y: auto;\n          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n          \n          .session-item {\n            background: #f8f9fa;\n            border-radius: 8px;\n            padding: 15px;\n            margin-bottom: 10px;\n            cursor: pointer;\n            border-left: 4px solid transparent;\n            transition: all 0.3s ease;\n            \n            &:hover {\n              background: #e9ecef;\n              border-left-color: var(--loginButtonBgColor, #3498db);\n            }\n            \n            &.selected {\n              background: #e3f2fd;\n              border-left-color: var(--loginButtonBgColor, #3498db);\n              box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);\n            }\n            \n            .session-name {\n              font-size: 1rem;\n              font-weight: 600;\n              color: #2c3e50 !important;\n              margin-bottom: 8px;\n            }\n            \n            .session-meta {\n              display: flex;\n              gap: 15px;\n              font-size: 0.85rem;\n              color: #7f8c8d !important;\n              \n              .session-date, .session-time {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n              }\n            }\n          }\n        }\n        \n        .session-details {\n          background: white;\n          border-radius: 12px;\n          padding: 25px;\n          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n          \n          .session-detail-title {\n            font-size: 1.3rem;\n            font-weight: 600;\n            color: #2c3e50 !important;\n            margin-bottom: 15px;\n          }\n          \n          .session-description {\n            color: #34495e !important;\n            line-height: 1.6;\n            margin-bottom: 20px;\n          }\n          \n          .session-speakers-section {\n            margin-top: 20px;\n            \n            .speakers-title {\n              font-size: 1.1rem;\n              font-weight: 600;\n              color: #2c3e50 !important;\n              margin-bottom: 15px;\n            }\n            \n            .speakers-grid {\n              display: flex;\n              gap: 15px;\n              flex-wrap: wrap;\n              \n              .speaker-card {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                background: #f8f9fa;\n                padding: 10px 15px;\n                border-radius: 8px;\n                \n                .speaker-avatar {\n                  img {\n                    width: 40px;\n                    height: 40px;\n                    border-radius: 50%;\n                  }\n                }\n                \n                .speaker-name {\n                  font-size: 0.9rem;\n                  font-weight: 500;\n                  color: #2c3e50 !important;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  // Infobooth\n  .infobooth-section {\n    .infobooth-content {\n      width: 100%;\n      height: 600px;\n\n      background: white;\n      border-radius: 12px;\n      padding: 30px;\n      color: #34495e !important;\n      line-height: 1.8;\n      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n    }\n  }\n}\n\n@media (max-width: 950px) {\n  .hotsite-container {\n    padding: 15px;\n    gap: 20px;\n  }\n\n  .content-section {\n    padding: 20px !important;\n  }\n\n  .schedule-section .schedule-content .schedule-layout {\n    grid-template-columns: 1fr !important;\n  }\n\n  .speakers-section .speakers-carousel {\n    padding: 0 40px;\n    \n    .carousel-btn {\n      width: 35px;\n      height: 35px;\n      \n      ion-icon {\n        font-size: 20px;\n      }\n    }\n    \n    .speakers-grid {\n      .speaker-card-large {\n        flex: 0 0 160px;\n        width: 160px;\n        height: 220px;\n      }\n    }\n  }\n  \n  .sponsors-section .sponsors-carousel {\n    padding: 0 40px;\n    \n    .carousel-btn {\n      width: 35px;\n      height: 35px;\n      \n      ion-icon {\n        font-size: 20px;\n      }\n    }\n    \n    .sponsors-grid-carousel {\n      .sponsor-card {\n        flex: 0 0 calc(25% - 15px);\n        min-width: 120px;\n      }\n    }\n  }\n  \n  .sponsors-section .sponsors-grid {\n    .sponsor-card {\n      flex: 0 0 calc(25% - 15px);\n      min-width: 120px;\n    }\n  }\n  \n  .sponsors-section .sponsors-grid .sponsor-card {\n    flex: 0 0 160px;\n  }\n\n  #schedule {\n    grid-template-columns: 1fr;\n  }\n\n  .sessions-info {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 2fr;\n    grid-template: \"sessions\" \"session-content\";\n  }\n\n  .sessions {\n    max-width: 100%;\n  }\n\n  .sessions-box ion-label h4{\n    max-width: calc(100vw - 60px);\n  }\n\n  .session-content {\n    max-width: calc(100vw - 30px);\n  }\n}\n\n@media (max-width: 600px) {\n  .speakers-section .speakers-carousel {\n    padding: 0 30px;\n    \n    .carousel-btn {\n      width: 30px;\n      height: 30px;\n      \n      ion-icon {\n        font-size: 18px;\n      }\n    }\n    \n    .speakers-grid {\n      .speaker-card-large {\n        flex: 0 0 150px;\n        width: 150px;\n        height: 210px;\n      }\n    }\n  }\n  \n  .sponsors-section .sponsors-carousel {\n    padding: 0 30px;\n    \n    .carousel-btn {\n      width: 30px;\n      height: 30px;\n      \n      ion-icon {\n        font-size: 18px;\n      }\n    }\n    \n    .sponsors-grid-carousel {\n      .sponsor-card {\n        flex: 0 0 calc(50% - 10px);\n        min-width: 130px;\n      }\n    }\n  }\n  \n  .sponsors-section .sponsors-grid {\n    .sponsor-card {\n      flex: 0 0 calc(50% - 10px);\n      min-width: 130px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
